import {
  Textarea as RawTextarea,
  TextareaProps as RawTextareaProps,
} from '@mantine/core';
import { useFormState } from 'components/elements/form';
import React from 'react';
import { useController } from 'react-hook-form';

export interface TextareaInputProps extends Omit<RawTextareaProps, 'type'> {
  type: 'textarea';
  name: string;
}

export default function TextareaInput(props: TextareaInputProps) {
  const {
    onChange,
    disabled,
    readOnly,
    name,
    type,
    error,
    placeholder,
    ...rest
  } = props;
  const formState = useFormState();
  const { field, fieldState } = useController({
    name,
  });

  const _disabled = formState.editable === false || disabled || readOnly;
  const _error = fieldState.error?.message || error;

  const _placeholder = React.useMemo(() => {
    if (_disabled) return undefined;
    return placeholder;
  }, [_disabled, placeholder]);

  const withAsterisk = React.useMemo(() => {
    if (_disabled) return false;
    if (rest.required || rest.withAsterisk) return true;
  }, [_disabled, rest.required, rest.withAsterisk]);

  return (
    <RawTextarea
      {...rest}
      {...field}
      value={field.value}
      onChange={(e) => {
        field.onChange(e.currentTarget.value);
        onChange?.(e);
      }}
      placeholder={_placeholder}
      disabled={_disabled}
      error={_error}
      withAsterisk={withAsterisk}
    />
  );
}
